<template>
  <div class="wapper">
    1122
    <div class="depart-wapper">
      <el-tree :expand-on-click-node="false"
               default-expand-all
               :data="departments"
               @node-click="nodeClick">
      </el-tree>
    </div>
    <div class="userinfo-wapper">
      <el-table :data="userinfos"
                size='mini'
                empty-text
                v-if="userinfos != null && userinfos.length > 0">
        <el-table-column width="160"
                         label="用户头像">
          <template slot-scope="scope">
            <img :src="scope.row.avatar || 'https://rs.juyoufuli.com/assets/staffs/timg.jpg'"
                 class="avatar">
          </template>
        </el-table-column>
        <el-table-column prop="name"
                         label="用户名称"></el-table-column>
        <el-table-column prop="position"
                         label="职务"></el-table-column>
        <el-table-column prop="email"
                         label="邮箱"></el-table-column>
        <el-table-column prop="mobile"
                         label="手机号"></el-table-column>
        <el-table-column label="详情"
                         fixed="right"
                         width="80">
          <template slot-scope="scope">
            <el-button @click="infoDetail(scope.row)"
                       type="text"
                       size="small"
                       v-auth="'view'">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-else-if="currDepartment != null"
           class="department-show">
        {{currDepartment.label}}
      </div>
    </div>
    <!-- 用户详情 -->
    <userDetail ref="userDetail"
                @setPassword="setPassword"
                @setRole="setRole">
    </userDetail>
  </div>
</template>

<script>
import _department from '@/service/department-service'
import _userinfo from '@/service/userinfo-service'
import userDetail from '@/views/userinfo/mail-detail'
export default {
  components: {
    userDetail,
  },
  data () {
    return {
      departments: null,
      userinfos: null,
      currDepartment: null,
      operations: null
    }
  },
  mounted () {
    // 获取部门信息
    _department.getDepartmentTree(response => {
      this.departments = response
      this.currDepartment = response[0]
    })
  },
  methods: {
    nodeClick (data) {
      this.currDepartment = data
      this.getUsersByDepartment()
    },
    // 根据部门查询员工列表
    getUsersByDepartment () {
      _userinfo.getUsersByDepartment(this.currDepartment.id, response => {
        this.userinfos = response
      })
    },
    // 用户详情
    infoDetail (row) {
      this.$refs.userDetail.show(row)
    }
  }
}
</script>

<style scoped>
.wapper {
  position: relative;
}
.el-tree {
  background: #f9f9f9;
}
.depart-wapper {
  width: 350px;
  height: 100%;
  padding: 10px;
  border-right: 1px solid #d6dbe5;
  position: absolute;
  top: 0;
  left: 0;
  overflow-y: auto;
}
.userinfo-wapper {
  display: inline-block;
  width: calc(100% - 351px);
  height: 100%;
  padding: 10px;
  position: absolute;
  top: 0;
  left: 350px;
  overflow-y: auto;
}
.avatar {
  width: 35px;
  height: 35px;
  border-radius: 3px;
}
.department-show {
  font-size: 18px;
  text-align: center;
  padding: 10px;
  padding-bottom: 20px;
  border-bottom: 1px solid #d6dbe5;
}
</style>